/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxType } from './';
import {
    TaxTypeFromJSON,
    TaxTypeFromJSONTyped,
    TaxTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Tax
 */
export interface Tax {
    /**
     * 
     * @type {TaxType}
     * @memberof Tax
     */
    type?: TaxType;
    /**
     * The tax value set in /freelancer/company/FREELANCER_COMPANY_ID/my-business-details
     * @type {number}
     * @memberof Tax
     */
    defaultPercent?: number;
    /**
     * The current select tax for the quote (default for unsaved draft quote)
     * @type {number}
     * @memberof Tax
     */
    selectedPercent?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Tax
     */
    eligiblePercents?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Tax
     */
    editableRule?: TaxEditableRuleEnum;
    /**
     * Replaced by editableRule
     * @type {boolean}
     * @memberof Tax
     * @deprecated
     */
    isExempted?: boolean;
}


/**
 * @export
 */
export const TaxEditableRuleEnum = {
    Editable: 'EDITABLE',
    NotEditable: 'NOT_EDITABLE',
    CrossBorderNotEditable: 'CROSS_BORDER_NOT_EDITABLE',
    ExemptedNotEditable: 'EXEMPTED_NOT_EDITABLE'
} as const;
export type TaxEditableRuleEnum = typeof TaxEditableRuleEnum[keyof typeof TaxEditableRuleEnum];


/**
 * Check if a given object implements the Tax interface.
 */
export function instanceOfTax(value: object): value is Tax {
    return true;
}

export function TaxFromJSON(json: any): Tax {
    return TaxFromJSONTyped(json, false);
}

export function TaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tax {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : TaxTypeFromJSON(json['type']),
        'defaultPercent': json['defaultPercent'] == null ? undefined : json['defaultPercent'],
        'selectedPercent': json['selectedPercent'] == null ? undefined : json['selectedPercent'],
        'eligiblePercents': json['eligiblePercents'] == null ? undefined : json['eligiblePercents'],
        'editableRule': json['editableRule'] == null ? undefined : json['editableRule'],
        'isExempted': json['isExempted'] == null ? undefined : json['isExempted'],
    };
}

export function TaxToJSON(value?: Tax | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': TaxTypeToJSON(value['type']),
        'defaultPercent': value['defaultPercent'],
        'selectedPercent': value['selectedPercent'],
        'eligiblePercents': value['eligiblePercents'],
        'editableRule': value['editableRule'],
        'isExempted': value['isExempted'],
    };
}

